import React from 'react';
import { ApplyPresetConnected } from '../../containers/orders-drawer/sections/apply-preset';
import { BulkUpdate } from '../../components/orders-drawer/sections/bulk-update';
import { AddressValidation } from '../../containers/orders-drawer/sections/address-validation';
import { OrderedItems } from '../../containers/orders-drawer/sections/ordered-items';

export const multiSelectionComponentMap = [
  {
    name: 'AddressValidation',
    v2Name: 'BulkValidate',
    render: () => <AddressValidation />,
  },
  {
    name: 'ApplyPreset',
    v2Name: 'BulkPresets',
    render: () => <ApplyPresetConnected />,
  },
  {
    name: 'BulkUpdate',
    v2Name: 'BulkUpdate',
    render: () => <BulkUpdate />,
  },
  {
    name: 'OrderedItems',
    v2Name: 'BulkItems',
    render: () => <OrderedItems />,
  },
];
